"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const rename_1 = require("../../../app/dist/rename");
exports.toolDef = {
    name: 'loom_rename',
    description: "Rename a document: updates its title (and synced body H1) only. The permanent id and the filename are unchanged — identity is not derived from the title, so backlinks stay intact. Use this tool to rename Loom docs — do not edit files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            oldId: { type: 'string', description: 'Current document id' },
            newTitle: { type: 'string', description: 'New human-readable title (the id is NOT changed)' },
        },
        required: ['oldId', 'newTitle'],
    },
};
async function handle(root, args) {
    // Resolve the agent-supplied oldId at the delivery boundary: gives suggest-on-miss
    // and converts a filename-stem to the canonical id so findDocumentById locates the doc.
    const { id: resolvedOldId } = await (0, dist_1.resolveDocIdOrThrow)(root, args['oldId']);
    const result = await (0, rename_1.rename)({ oldId: resolvedOldId, newTitle: args['newTitle'] }, {
        loadDoc: dist_1.loadDoc,
        saveDoc: dist_1.saveDoc,
        getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root),
        findDocumentById: dist_1.findDocumentById,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
